// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as React from "react";
import * as Caml_obj from "../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as Belt_SortArray from "../../../../node_modules/rescript/lib/es6/belt_SortArray.js";
import * as PDPForm$Showside from "./PDPForm.bs.js";
import * as Product$Showside from "../types/Product.bs.js";
import * as Currency$Showside from "../utils/Currency.bs.js";
import * as DataAttribute$Showside from "../utils/DataAttribute.bs.js";
import * as ReactDOMUtils$Showside from "../utils/ReactDOMUtils.bs.js";
import * as ResizeObserver$Showside from "../utils/ResizeObserver.bs.js";
import * as StylableElement$Showside from "./StylableElement.bs.js";
import * as ProductDetailsConfig$Showside from "../types/ProductDetailsConfig.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
import * as ProductDetailsContext$Showside from "../context/ProductDetailsContext.bs.js";
function ProductPrice$DiscountedPercentage(Props) {
  var classNameOpt = Props.className;
  var sizeOpt = Props.size;
  var parsedPrice = Props.parsedPrice;
  var parsedCompareAtPrice = Props.parsedCompareAtPrice;
  var containerRef = Props.containerRef;
  var className = classNameOpt !== undefined ? classNameOpt : "";
  var size = sizeOpt !== undefined ? sizeOpt : /* Base */0;
  var containerBoundsWidth = Belt_Option.mapWithDefault(ResizeObserver$Showside.useResizeObserver(undefined, containerRef), 99999, function (size) {
    return size.width;
  });
  var discountedPercentage;
  if (parsedPrice !== undefined && parsedCompareAtPrice !== undefined) {
    var actualCompareAtPrice = Math.max(parsedPrice.value, parsedCompareAtPrice.value);
    var actualPrice = Math.min(parsedPrice.value, parsedCompareAtPrice.value);
    var savings = actualPrice - actualCompareAtPrice;
    discountedPercentage = Math.round(savings / Math.max(actualCompareAtPrice, 1.0) * 100);
  } else {
    discountedPercentage = undefined;
  }
  var format = function (percentage) {
    if (size) {
      return "SAVE " + Math.abs(percentage).toString() + "%";
    } else {
      return "" + percentage.toString() + "%";
    }
  };
  var willShowDiscountPercentage = containerBoundsWidth > 100;
  if (discountedPercentage !== undefined && discountedPercentage < 0.0 && willShowDiscountPercentage) {
    return React.createElement("div", {
      "aria-hidden": true,
      className: Cn.make([StylableElement$Showside.toString("product-card__discount-badge"), size ? CSS$Showside.prefix("inline-block px-2 py-1 border border-product-discount-main text-product-discount-main text-lg") : CSS$Showside.prefix("inline px-1 py-0.5 bg-product-discount-main text-product-discount-label rounded-custom text-base"), className])
    }, format(discountedPercentage));
  } else {
    return null;
  }
}
ProductPrice$DiscountedPercentage.displayName = "ProductPrice.DiscountedPercentage";
var DiscountedPercentage = {
  make: ProductPrice$DiscountedPercentage
};
function ProductPrice$Labels(Props) {
  var product = Props.product;
  var variant = Props.variant;
  var at = Props.at;
  var kind = Props.kind;
  var alignOpt = Props.align;
  var className = Props.className;
  var align = alignOpt !== undefined ? alignOpt : /* Right */1;
  var match = ConfigurationProvider$Showside.use(undefined);
  var config = match.config;
  var pdpConfig = ProductDetailsContext$Showside.use(undefined);
  var labels = Belt_Array.keepMap(Belt_Array.map(Belt_Array.keep(Belt_Array.keep(pdpConfig.priceLabels, function (label) {
    if (label.showAs === /* Suffix */1 && kind === /* Suffix */1) {
      return true;
    } else if (label.showAs === /* Prefix */0) {
      return kind === /* Prefix */0;
    } else {
      return false;
    }
  }), function (suffix) {
    if (suffix.visibleInProductCard) {
      return true;
    } else {
      return at === /* PDP */0;
    }
  }), function (suffix) {
    return ProductDetailsConfig$Showside.Content.renderContent(undefined, className, product, variant, config, suffix.content);
  }), function (a) {
    return a;
  });
  var textAlignCn = align ? "text-right" : "text-left";
  if (labels.length !== 0) {
    return React.createElement("div", {
      className: CSS$Showside.prefix(textAlignCn)
    }, Belt_Array.mapWithIndex(labels, function (i, label) {
      if (kind) {
        return React.createElement(DataAttribute$Showside.make, {
          dataTestId: "pdp-product-price-suffix",
          children: React.createElement("div", {
            className: CSS$Showside.prefix(Cn.make(["font-normal", "leading-normal", "text-secondary", textAlignCn]))
          }, label),
          key: String(i)
        });
      } else {
        return React.createElement(DataAttribute$Showside.make, {
          dataTestId: "pdp-product-price-prefix",
          children: React.createElement("div", {
            className: CSS$Showside.prefix(Cn.make(["font-normal", "leading-normal", "text-secondary", textAlignCn]))
          }, label),
          key: String(i)
        });
      }
    }));
  } else {
    return null;
  }
}
ProductPrice$Labels.displayName = "ProductPrice.Labels";
var Labels = {
  make: ProductPrice$Labels
};
function multiply(multiplier, currency) {
  return {
    value: currency.value * multiplier,
    currency: currency.currency,
    symbol: currency.symbol
  };
}
function getPriceRanges(multiplier, hideOutOfStock, product) {
  var allVariantPrices = Belt_Array.map(Belt_Array.keep(Product$Showside.getAllVariants(product), function (variant) {
    if (variant.availability !== /* OutOfStock */0) {
      return true;
    } else {
      return !hideOutOfStock;
    }
  }), function (variant) {
    return variant.price;
  });
  var formatRange = function (prices) {
    var prices$1 = Belt_Array.map(Belt_SortArray.stableSortBy(Belt_Array.map(Belt_Array.keepMap(Belt_Array.map(prices, Currency$Showside.parse), function (parsed) {
      return parsed;
    }), function (param) {
      return multiply(multiplier, param);
    }), function (a, b) {
      if (a.value > b.value) {
        return -1;
      } else if (a.value === b.value) {
        return 0;
      } else {
        return 1;
      }
    }), Currency$Showside.format);
    var largestPrice = Belt_Array.get(prices$1, 0);
    var lowestPrice = Belt_Array.get(prices$1, prices$1.length - 1 | 0);
    if (largestPrice !== undefined && lowestPrice !== undefined && largestPrice !== lowestPrice) {
      return "" + lowestPrice + "-" + largestPrice + "";
    }
  };
  var rangePrice = formatRange(Belt_Array.keepMap(allVariantPrices, function (price) {
    if (typeof price === "number") {
      return;
    } else if (price.TAG === /* Regular */0) {
      return price._0;
    } else {
      return price._0.price;
    }
  }));
  var rangeCompareAtPrice = formatRange(Belt_Array.keepMap(allVariantPrices, function (price) {
    if (typeof price === "number" || price.TAG === /* Regular */0) {
      return;
    } else {
      return price._0.regularPrice;
    }
  }));
  return [rangePrice, rangeCompareAtPrice];
}
function getDisplayPrice(multiplierOpt, hideOutOfStock, product, variant, style) {
  var multiplier = multiplierOpt !== undefined ? multiplierOpt : 1;
  var match = Product$Showside.Variant.getVariantPrices(variant);
  var compareAtPrice = match[0];
  var price = Belt_Option.getWithDefault(match[1], compareAtPrice);
  var match$1 = getPriceRanges(multiplier, hideOutOfStock, product);
  var rangePrice = match$1[0];
  var style$1 = style && rangePrice === undefined ? /* Default */0 : style;
  if (style$1) {
    return [{
      TAG: /* String */1,
      _0: rangePrice
    }, {
      TAG: /* String */1,
      _0: match$1[1]
    }];
  } else {
    return [{
      TAG: /* Parsed */0,
      _0: Belt_Option.map(Currency$Showside.parse(price), function (param) {
        return multiply(multiplier, param);
      })
    }, {
      TAG: /* Parsed */0,
      _0: Belt_Option.map(Currency$Showside.parse(compareAtPrice), function (param) {
        return multiply(multiplier, param);
      })
    }];
  }
}
function getHumanReadablePriceBreakdown(price, compareAtPrice) {
  if (price.TAG === /* Parsed */0) {
    var price$1 = price._0;
    if (price$1 === undefined) {
      return;
    }
    if (compareAtPrice.TAG !== /* Parsed */0) {
      return;
    }
    var compareAtPrice$1 = compareAtPrice._0;
    if (compareAtPrice$1 !== undefined) {
      return "current price: " + Currency$Showside.format(price$1) + ", original price: " + Currency$Showside.format(compareAtPrice$1) + "";
    } else {
      return "current price: " + Currency$Showside.format(price$1) + "";
    }
  }
  var price$2 = price._0;
  if (price$2 === undefined) {
    return;
  }
  if (compareAtPrice.TAG === /* Parsed */0) {
    return;
  }
  var compareAtPrice$2 = compareAtPrice._0;
  if (compareAtPrice$2 !== undefined) {
    return "current price: " + price$2 + ", original price: " + compareAtPrice$2 + "";
  } else {
    return "current price: " + price$2 + "";
  }
}
function ProductPrice(Props) {
  var at = Props.at;
  var product = Props.product;
  var variant = Props.variant;
  var sizeOpt = Props.size;
  var style = Props.style;
  var priceBlockStylableClassName = Props.priceBlockStylableClassName;
  var priceStylableClassName = Props.priceStylableClassName;
  var salePriceStylableClassName = Props.salePriceStylableClassName;
  var alignOpt = Props.align;
  var marginTopOpt = Props.marginTop;
  var showMaxPriceOpt = Props.showMaxPrice;
  var labelsEnabledOpt = Props.labelsEnabled;
  var showDiscountedPercentageOpt = Props.showDiscountedPercentage;
  var minPriceFirstOpt = Props.minPriceFirst;
  var multilineOpt = Props.multiline;
  var textColor = Props.textColor;
  var boldOpt = Props.bold;
  var multiplierOpt = Props.multiplier;
  var size = sizeOpt !== undefined ? sizeOpt : /* Md */1;
  var align = alignOpt !== undefined ? alignOpt : /* Left */0;
  var marginTop = marginTopOpt !== undefined ? marginTopOpt : true;
  var showMaxPrice = showMaxPriceOpt !== undefined ? showMaxPriceOpt : true;
  var labelsEnabled = labelsEnabledOpt !== undefined ? labelsEnabledOpt : true;
  var showDiscountedPercentage = showDiscountedPercentageOpt !== undefined ? showDiscountedPercentageOpt : true;
  var minPriceFirst = minPriceFirstOpt !== undefined ? minPriceFirstOpt : true;
  var multiline = multilineOpt !== undefined ? multilineOpt : false;
  var bold = boldOpt !== undefined ? boldOpt : true;
  var multiplier = multiplierOpt !== undefined ? multiplierOpt : 1;
  var match = PDPForm$Showside.use(undefined);
  var pendingFields = match.pendingFields;
  var formProduct = match.product;
  var match$1 = ConfigurationProvider$Showside.use(undefined);
  var pendingFieldsNum = Belt_Option.mapWithDefault(pendingFields, 0, function (prim) {
    return prim.length;
  });
  var ref = React.useRef(null);
  var style$1 = Belt_Option.getWithDefault(Belt_Option.keep(Belt_Option.map(ConfigurationProvider$Showside.use(undefined).config.transitiveAccount, function (account) {
    return account.productPriceStyle;
  }), function (style) {
    if (style && pendingFieldsNum <= 0) {
      return Caml_obj.notequal(product.id, Belt_Option.map(formProduct, function (product) {
        return product.id;
      }));
    } else {
      return true;
    }
  }), /* Default */0);
  var style$2 = style !== undefined && pendingFields === undefined ? style : style$1;
  var match$2 = getDisplayPrice(multiplier, match$1.config.settings.hideOutOfStock, product, variant, style$2);
  var displayCompareAtPrice = match$2[1];
  var displayPrice = match$2[0];
  var priceStr;
  priceStr = displayPrice.TAG === /* Parsed */0 ? Belt_Option.mapWithDefault(displayPrice._0, "", Currency$Showside.format) : Belt_Option.getWithDefault(displayPrice._0, "");
  var compareAtPriceStr;
  compareAtPriceStr = displayCompareAtPrice.TAG === /* Parsed */0 ? Belt_Option.mapWithDefault(displayCompareAtPrice._0, "", Currency$Showside.format) : Belt_Option.getWithDefault(displayCompareAtPrice._0, "");
  var sizeClassName1;
  switch (size) {
    case /* Xl */0:
      sizeClassName1 = "text-2xl";
      break;
    case /* Md */1:
      sizeClassName1 = "text-xl";
      break;
    case /* Sm */2:
      sizeClassName1 = "text-lg";
      break;
  }
  var sizeClassName2;
  switch (size) {
    case /* Xl */0:
      sizeClassName2 = "text-lg";
      break;
    case /* Md */1:
    case /* Sm */2:
      sizeClassName2 = "text-base";
      break;
  }
  var selfAlignCn = align ? "self-end" : "self-start";
  var renderPrice = function (param) {
    var tmp = {
      children: priceStr
    };
    if (priceStylableClassName !== undefined) {
      tmp.className = Caml_option.valFromOption(priceStylableClassName);
    }
    return React.createElement(DataAttribute$Showside.make, {
      dataTestId: "pdp-product-price",
      children: React.createElement("div", {
        className: CSS$Showside.prefix(Cn.make([bold ? "font-semibold" : "", "inline-flex space-x-2", selfAlignCn, sizeClassName1, Belt_Option.getWithDefault(textColor, "text-primary")]))
      }, labelsEnabled ? React.createElement(ProductPrice$Labels, {
        product: product,
        variant: variant,
        at: at,
        kind: /* Prefix */0,
        align: align,
        className: CSS$Showside.prefix(sizeClassName1)
      }) : null, React.createElement("div", {
        "aria-hidden": true
      }, React.createElement(StylableElement$Showside.make, tmp)))
    });
  };
  var renderCompareAtPrice = function (param) {
    var tmp = {
      children: compareAtPriceStr
    };
    if (salePriceStylableClassName !== undefined) {
      tmp.className = Caml_option.valFromOption(salePriceStylableClassName);
    }
    return React.createElement(DataAttribute$Showside.make, {
      dataTestId: "pdp-product-sale-price",
      children: React.createElement("div", {
        "aria-hidden": true,
        className: CSS$Showside.prefix(Cn.make(["inline-block line-through", bold ? "font-medium" : "", sizeClassName2, Belt_Option.getWithDefault(textColor, "text-tertiary")]))
      }, React.createElement(StylableElement$Showside.make, tmp))
    });
  };
  var discountedPercentage;
  discountedPercentage = displayPrice.TAG === /* Parsed */0 && displayCompareAtPrice.TAG === /* Parsed */0 && showDiscountedPercentage ? React.createElement(ProductPrice$DiscountedPercentage, {
    className: CSS$Showside.prefix(sizeClassName2),
    parsedPrice: displayPrice._0,
    parsedCompareAtPrice: displayCompareAtPrice._0,
    containerRef: ref
  }) : null;
  var firstRow = showMaxPrice && priceStr !== compareAtPriceStr ? React.createElement("div", {
    className: CSS$Showside.prefix(Cn.make(["inline-flex text-left justify-end flex-wrap", multiline && align === /* Left */0 ? "items-start" : "items-end", multiline ? minPriceFirst ? "flex-col-reverse space-y-reverse" : "flex-col" : minPriceFirst ? "flex-row-reverse space-x-reverse" : "flex-row", multiline ? "space-y-2" : "space-x-2"]))
  }, React.createElement("div", {
    className: CSS$Showside.prefix("flex items-center justify-center space-x-2")
  }, renderCompareAtPrice(undefined), discountedPercentage), renderPrice(undefined)) : renderPrice(undefined);
  var tmp = {
    ref: ReactDOMUtils$Showside.Ref.domRef(ref),
    className: CSS$Showside.prefix(Cn.make(["flex flex-col space-y-2", marginTop ? "mt-2" : ""]))
  };
  var tmp$1 = getHumanReadablePriceBreakdown(displayPrice, displayCompareAtPrice);
  if (tmp$1 !== undefined) {
    tmp["aria-label"] = Caml_option.valFromOption(tmp$1);
  }
  var tmp$2 = {
    children: firstRow
  };
  if (priceBlockStylableClassName !== undefined) {
    tmp$2.className = Caml_option.valFromOption(priceBlockStylableClassName);
  }
  return React.createElement("div", tmp, React.createElement(StylableElement$Showside.make, tmp$2), labelsEnabled ? React.createElement(ProductPrice$Labels, {
    product: product,
    variant: variant,
    at: at,
    kind: /* Suffix */1,
    align: align,
    className: CSS$Showside.prefix(sizeClassName2)
  }) : null);
}
ProductPrice.displayName = "ProductPrice";
var make = ProductPrice;
export { DiscountedPercentage, Labels, multiply, getPriceRanges, getDisplayPrice, getHumanReadablePriceBreakdown, make };
/* react Not a pure module */